import React, { useContext, useEffect, useState } from 'react'
import "./Header.css"
import { Button, Container, Nav, Navbar } from "react-bootstrap";
import { FaCartPlus } from 'react-icons/fa';
import { Link } from "react-router-dom";
import swal from 'sweetalert'
import { CartContext } from './Context/CartContext';

const authUrl = "https://zomatourl.herokuapp.com/userinfo"

function Header() {
  const {cart} = useContext(CartContext)
  const [user, setUser] = useState([])

  useEffect(() => {
    fetchUser();
  }, [])

  useEffect(() => {
    ConditionalHandle();
  }, [user])

  const fetchUser = () => {
    fetch(authUrl, {
      method: "GET",
      headers: {
        "x-access-token": localStorage.getItem("authToken")
      }
    })
      .then(res => res.json())
      .then(data => {
        setUser(data)
      })
      .catch(err => {
        console.log(err);
      })
  }

  const handleLogout = () => {
    setUser("")
    localStorage.removeItem('authToken')
    localStorage.removeItem('userdata')
    if (user.name) {
      swal("Logout Successfully");
    }
  }

  const ConditionalHandle = () => {
    if (user.name) {
      let data = user;
      let outputArray = [data.name, data.email, data.phone, data.role];
      // console.log(outputArray);
      localStorage.setItem('userdata', outputArray);
      return (
        <>
            <h4 className='text-white pe-3 mt-1'>Hi {outputArray[0]} </h4>
          <Link to={'/'} className="me-3">
            <Button variant='outline-light' onClick={handleLogout}>Logout</Button>
          </Link>
        </>
      )
    }
    else {
      return (
        <>
          <Link to={'/login'} className="me-3">
            <Button variant='outline-light'>Login</Button>
          </Link>
          <Link to={'/register'} className="me-3">
            <Button variant='outline-light'>Create an Account</Button>
          </Link>
        </>
      )
    }
  }

  return (
    <React.Fragment>
      <Navbar className='sticky-top' bg="danger" expand="lg">
        <Container>
          <Navbar.Brand>
            <Link to={'/'} className="link" >
              <h1 className="logo">e!</h1>
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" className='basic-navbar-nav' />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <ConditionalHandle />
              <Link to={'/placeorder'} className="me-3">
                <Button variant='outline-light'>
                  <FaCartPlus style={{ fontSize: 25, marginRight: "5px" }} />
                  <span className='cartvalue fw-bold'>{cart.totalItems ? cart.totalItems : 0}</span>
                </Button>
              </Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </React.Fragment>
  );
}

export default Header